import { render, staticRenderFns } from "./AfflictionSightingForm.vue?vue&type=template&id=70676db2"
import script from "./AfflictionSightingForm.vue?vue&type=script&lang=js"
export * from "./AfflictionSightingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports